<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
  <app-simple-autocomplete-value-accessor [label]="label"
                                          [data]="data"
                                          (changed)="select($event)">
  </app-simple-autocomplete-value-accessor>
</mat-dialog-content>
